import { adminApiService } from '../services/api';

export const isAuthenticated = async () => {
  try {
    const response = await adminApiService.verifyAdminAuth();

    if (response.ok) {
      const data = await response.json();
      return { authorized: true, user: data.user };
    }

    if (response.status === 401) {
      return { authorized: false, user: null };
    }

    return { authorized: false, user: null, error: "Unauthorized" };
  } catch (error) {
    console.error("Error in isAuthenticated:", error);
    return { authorized: false, user: null, error: "Network error" };
  }
};
